import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { motion } from "framer-motion";
import contactImg from "../../static/media/contact.webp";

const ContactCTA = () => {
  return (
    <Box
      sx={{
        position: "relative",
        backgroundColor: "#000",
        color: "#fff",
        py: { xs: 5, md: 7 },
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(180deg, #000 0%, #050008 48%, #1a0033 78%, #8000FF 130%)",
          zIndex: 1,
        }}
      />

      <Box
        component={motion.div}
        initial={{ opacity: 0, y: 35 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        sx={{
          position: "relative",
          zIndex: 2,
          maxWidth: "1200px",
          mx: "auto",
          px: { xs: 2.5, sm: 3, md: 6 },
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          justifyContent: "space-between",
          gap: { xs: 4, md: 7 },
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", md: "52%" },
            textAlign: { xs: "center", md: "left" },
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              mb: 3,
              fontSize: { xs: "1.9rem", sm: "2.3rem", md: "2.65rem" },
              lineHeight: 1.15,
              color: "#8000FF",
              textShadow: "0 0 10px rgba(128,0,255,0.6)",
            }}
          >
            ¿Deseas crear tu propia página web?
          </Typography>

          <Typography
            sx={{
              maxWidth: { xs: "100%", md: "720px" },
              mx: { xs: "auto", md: 0 },
              mb: 4,
              fontSize: { xs: "1rem", md: "1.1rem" },
              lineHeight: 1.75,
              color: "#e6e6e6",
            }}
          >
            Realizamos <strong>landing pages</strong>,{" "}
            <strong>automatizaciones para tu negocio</strong>,{" "}
            <strong>catálogos digitales</strong>,{" "}
            <strong>tiendas online</strong> y <strong>apps móviles</strong>.
            Optimizamos tu presencia digital con tecnologías modernas,
            velocidad, diseño de alto nivel y soluciones pensadas para impulsar
            tu marca.
          </Typography>

          <Button
            component="a"
            href="https://wa.me/593987763815?text=Solicito%20información"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              background: "linear-gradient(135deg, #3A0074, #8000FF)",
              color: "#fff",
              fontWeight: 700,
              px: { xs: 3.5, sm: 4.5 },
              py: 1.5,
              borderRadius: "30px",
              fontSize: { xs: "0.95rem", sm: "1.05rem" },
              boxShadow: "0 0 20px rgba(128,0,255,0.55)",
              transition: "all 0.3s ease",
              "&:hover": {
                background: "linear-gradient(135deg, #8000FF, #3A0074)",
                boxShadow: "0 0 35px rgba(128,0,255,0.85)",
                transform: "scale(1.05)",
              },
            }}
          >
            CONTÁCTANOS
          </Button>
        </Box>

        <Box
          component={motion.div}
          initial={{ opacity: 0, scale: 0.92 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.9 }}
          viewport={{ once: true }}
          sx={{
            width: { xs: "100%", sm: "82%", md: "48%" },
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={contactImg}
            alt="Desarrollo web profesional"
            sx={{
              width: "100%",
              maxWidth: { xs: 350, sm: 500 },
              height: { xs: 400, sm: 500 },
              objectFit: "cover",
              objectPosition: "center",
              borderRadius: { xs: 4, md: 5 },
              border: "1px solid rgba(128,0,255,0.35)",
              boxShadow: "0 24px 65px rgba(128,0,255,0.22)",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ContactCTA;